import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { motion } from "framer-motion";
import "../css/Contact.css";

export default function Contact() {
  const [status, setStatus] = useState("");

  return (
    <section className="contact">
      <div className="contact-bg" />

      <div className="contact-wrapper">
        {/* Header */}
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <span className="contact-label">Contact</span>
          <h2 className="contact-title">
            Let’s Start <span>Conversation</span>
          </h2>
          <p className="contact-lead">
            Whether you’re exploring our platform or ready to deploy at scale,
            our team is here to guide you.
          </p>
        </motion.div>

        <div className="contact-grid">
          {/* Info */}
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <div className="info-card">
              <h3>Contact Information</h3>

              <ul>
                <li><FaMapMarkerAlt /> <span>Bengaluru, India</span></li>
                <li><FaPhoneAlt /> <span>+91 86601 21705</span></li>
                <li><FaEnvelope /> <span>contact@inquizene.com</span></li>
                <li><FaClock /> <span>Mon – Fri · 9:00 AM – 6:00 PM</span></li>
              </ul>
            </div>

            <div className="contact-social">
              <a href="https://facebook.com/inquizene"><FaFacebookF /></a>
              <a href="https://twitter.com/inquizene"><FaTwitter /></a>
              <a href="https://linkedin.com/in/inquizene"><FaLinkedinIn /></a>
              <a href="https://instagram.com/inquizeneofficial"><FaInstagram /></a>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div
            className="contact-form-card"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <h3>Send Us a Message</h3>
            <p>Share your requirements and our team will get back within one business day.</p>

            <form
              action="https://formsubmit.co/contact@inquizene.com"
              method="POST"
              onSubmit={() => setStatus("Sending message...")}
            >
              {/* Required fields */}
              <input type="text" name="name" placeholder="Full Name" required />
              <input type="email" name="email" placeholder="Email Address" required />
              <input type="text" name="subject" placeholder="Subject" required />
              <textarea
                name="message"
                rows="5"
                placeholder="Tell us about your requirement"
                required
              />

              {/* Hidden config */}
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_next" value="https://inquizene.com/thank-you" />

              <button type="submit">Send Message</button>
            </form>

            {status && <div className="form-status">{status}</div>}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
